/*
 * Makri sepet çekmecesi (2026-10-14): "Sipariş notu" ve "Kupon kodu" alttan açılan paneller.
 * Çekmecenin içi her sepet güncellemesinde yeniden çizildiği için olaylar belgeye bağlanır.
 * Kupon: /cart/update.js { discount } — Shopify kodu sepete yazar, uygulanamıyorsa
 * discount_codes[].applicable=false döner; o zaman kod geri alınır ve hata gösterilir.
 */
(() => {
  if (window.makriCartDrawerInitialized) return;
  window.makriCartDrawerInitialized = true;

  const drawerInner = () => document.querySelector('cart-drawer .drawer__inner');

  function closeSheets() {
    const inner = drawerInner();
    if (!inner) return;
    inner.querySelectorAll('.makri-sheet, .makri-sheet__backdrop').forEach((el) => (el.hidden = true));
    inner.querySelectorAll('[data-makri-sheet-open]').forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
  }

  function openSheet(id, trigger) {
    closeSheets();
    const sheet = document.getElementById(id);
    if (!sheet) return;
    sheet.hidden = false;
    const backdrop = sheet.parentElement.querySelector('.makri-sheet__backdrop');
    if (backdrop) backdrop.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    const field = sheet.querySelector('textarea, input[type="text"]');
    if (field) field.focus();
  }

  function sectionsToRender() {
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function renderSections(sections) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !sections) return;
    const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const source = html.querySelector('.drawer__inner');
    const target = drawerInner();
    if (source && target) target.innerHTML = source.innerHTML;
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const bubbleHtml = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const bubbleSource = bubbleHtml.querySelector('.shopify-section');
      if (bubbleSource) bubble.innerHTML = bubbleSource.innerHTML;
    }
  }

  function updateDiscounts(codes) {
    return fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        discount: codes.join(','),
        sections: sectionsToRender(),
        sections_url: window.location.pathname,
      }),
    }).then((response) => response.json());
  }

  function currentCodes(form) {
    return (form.elements.current.value || '')
      .split(',')
      .map((code) => code.trim())
      .filter(Boolean);
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-makri-sheet-open]');
    if (opener) {
      event.preventDefault();
      openSheet(opener.dataset.makriSheetOpen, opener);
      return;
    }
    if (event.target.closest('[data-makri-sheet-close]')) {
      event.preventDefault();
      closeSheets();
      return;
    }
    const remove = event.target.closest('[data-makri-coupon-remove]');
    if (remove) {
      event.preventDefault();
      const form = remove.closest('form');
      const rest = currentCodes(form).filter((code) => code !== remove.dataset.makriCouponRemove);
      updateDiscounts(rest).then((cart) => renderSections(cart.sections));
    }
  });

  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape' && document.querySelector('.makri-sheet:not([hidden])')) {
      event.stopPropagation();
      closeSheets();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-makri-coupon]');
    if (!form) return;
    event.preventDefault();

    const code = form.elements.code.value.trim();
    const error = form.querySelector('.makri-coupon__error');
    if (!code) {
      form.elements.code.focus();
      return;
    }
    const before = currentCodes(form);
    if (before.some((existing) => existing.toUpperCase() === code.toUpperCase())) {
      closeSheets();
      return;
    }

    const button = form.querySelector('[type="submit"]');
    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    error.hidden = true;

    updateDiscounts([...before, code])
      .then((cart) => {
        const added = (cart.discount_codes || []).find(
          (entry) => entry.code.toUpperCase() === code.toUpperCase()
        );
        if (added && added.applicable) {
          renderSections(cart.sections);
          return;
        }
        // Uygulanamayan kodu sepette bırakma: ödeme sayfasında da hata gösterir.
        return updateDiscounts(before).then((restored) => {
          renderSections(restored.sections);
          const sheet = document.getElementById('MakriSheet-Coupon');
          const opener = document.querySelector('[data-makri-sheet-open="MakriSheet-Coupon"]');
          if (sheet && opener) openSheet('MakriSheet-Coupon', opener);
          const freshForm = document.querySelector('[data-makri-coupon]');
          if (freshForm) {
            freshForm.elements.code.value = code;
            freshForm.querySelector('.makri-coupon__error').hidden = false;
          }
        });
      })
      .catch(() => {
        error.hidden = false;
      })
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      });
  });
})();
